module.exports = __webpack_public_path__ + "img/2.bf1389d3.png";